import { faHeadset, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {Fragment, useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Container
} from "reactstrap";
import cx from 'classnames';
import { usePopupContext } from './context/popupContext';
import { getSessionValue } from './Appcommon';

function Popup(props){
    let {isInbox} = props;
    //const {incomingCallInfo} = useUsersContext();
    let {callInfo, onIncomingCallMonitor} = usePopupContext();
    let [content, setMessageContent] = useState("New Incomgin call landing to u");
    let [leadUrl, setLeadUrl] = useState("");
    let [btname, setBtnName] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    useEffect(() => {
        let appid = getSessionValue('appid');
        let userid = getSessionValue('loginuserid');
        if(callInfo.appid !== undefined && callInfo.appid === appid){
            if(callInfo.userid === userid){
                setMessageContent(callInfo.msgContent);
                setLeadUrl(callInfo.leadUrl);
                setBtnName(callInfo.btnname);
                openFilterModal();
                onIncomingCallMonitor({});
            }
        }
		  return () => {
			
		  };
	}, [callInfo]);
    const openFilterModal = () => {
        setIsModalOpen(true);
      };
    const closeFilterModal = () => {
        setIsModalOpen(false);
	};

    const openLink = (url) => {
        closeFilterModal();
        window.open(url, "_blank");
    }
    return(
        <Fragment>
            <div class="ui-theme-settings">
                <div className={cx("call-alert-popup", {'hide': !isModalOpen})}>
                    
				        <Container>
                            <Card className="main-card border">
                                <CardHeader className={`le-card-header container-header`}>
                                    Incoming Call!
                                    <button aria-label="Close" className='btn-close' onClick={(e) => closeFilterModal(e)}></button>
                                </CardHeader>
                                <CardBody>
                                    <div className='alert-content'>
                                        <div dangerouslySetInnerHTML={{ __html: content }} />
                                    </div>
                                    <div className='mt-4 btn-container'>
                                        <button className={cx("btn btn-success btn-lg ", {'hide': leadUrl == ""})}  onClick={(e) => openLink(leadUrl)}>{btname}</button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Container>
				</div>
            </div>
        </Fragment>
    )
}

export default Popup;
